import { SupplierTrack } from './supplier-track';

export class SupplierTrackingFilter {
    //ezek már le vannak töltve csak a modosultakat illetve az ujakat kell majd leszedni
    trackDoneList: Array<SupplierTrack> = [];
    supplierRegionID: string;
    date: string;
}
